var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagonLeftCorner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 659 592.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.8 38.4 63.6 99 116.8 129.5 170.3 99.4 170.5 38.8 117.2 8.3 63.8 38.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.2 8.3 63.8 38.4 63.6 99 90.2 84 90.4 53.7 117.1 38.6 117.2 8.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143.7 23.6 90.3 53.7 90.1 114.3 116.8 99.2 116.9 68.9 143.6 53.9 143.7 23.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.5 38.8 117 68.9 116.8 129.5 170.3 99.4 170.5 38.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.8 129.2 116.6 189.8 169.9 220.3 223.3 190.2 223.5 129.6 170.2 99.1 116.8 129.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.3 99.1 116.8 129.2 116.6 189.8 143.2 174.8 143.4 144.5 170.2 129.3 170.3 99.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196.8 114.3 143.3 144.5 143.1 205 169.8 190 170 159.7 196.7 144.7 196.8 114.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.5 129.6 170.1 159.7 169.9 220.3 223.3 190.2 223.5 129.6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.1 129.2 9.9 189.8 63.2 220.3 116.6 190.2 116.8 129.6 63.6 99.1 10.1 129.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.6 99.1 10.1 129.2 9.9 189.8 36.5 174.8 36.7 144.5 63.5 129.3 63.6 99.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.1 114.3 36.6 144.5 36.4 205 63.2 190 63.3 159.7 90 144.7 90.1 114.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.8 129.6 63.4 159.7 63.2 220.3 116.6 190.2 116.8 129.6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170 220.3 169.8 280.9 223.1 311.3 276.5 281.2 276.7 220.6 223.5 190.2 170 220.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.5 190.2 170 220.3 169.8 280.9 196.4 265.9 196.6 235.5 223.4 220.4 223.5 190.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250 205.4 196.5 235.5 196.3 296.1 223.1 281 223.2 250.8 249.9 235.8 250 205.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "276.7 220.6 223.3 250.8 223.1 311.3 276.5 281.2 276.7 220.6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.3 220.3 63.1 280.9 116.4 311.3 169.8 281.2 170 220.6 116.8 190.2 63.3 220.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.8 190.2 63.3 220.3 63.1 280.9 89.7 265.9 90 235.5 116.7 220.4 116.8 190.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143.3 205.4 89.8 235.5 89.7 296.1 116.4 281 116.5 250.8 143.2 235.8 143.3 205.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170 220.6 116.6 250.8 116.4 311.3 169.8 281.2 170 220.6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.2 311.4 223.1 371.9 276.3 402.4 329.8 372.3 330 311.7 276.7 281.2 223.2 311.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "276.7 281.2 223.2 311.4 223.1 371.9 249.7 356.9 249.9 326.6 276.6 311.5 276.7 281.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "303.2 296.5 249.8 326.6 249.6 387.2 276.3 372.1 276.4 341.8 303.1 326.8 303.2 296.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "330 311.7 276.5 341.8 276.3 402.4 329.8 372.3 330 311.7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.5 311.2 116.3 371.8 169.5 402.3 223 372.1 223.2 311.6 169.9 281.1 116.5 311.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "169.9 281.1 116.5 311.2 116.3 371.8 142.9 356.8 143.1 326.4 169.8 311.3 169.9 281.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196.4 296.3 143 326.4 142.8 387 169.5 372 169.6 341.7 196.3 326.7 196.4 296.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.2 311.6 169.7 341.7 169.5 402.3 223 372.1 223.2 311.6"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.7 311.1 9.5 371.7 62.8 402.1 116.2 372 116.4 311.4 63.2 280.9 9.7 311.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.2 280.9 9.7 311.1 9.5 371.7 36.2 356.7 36.4 326.3 63.1 311.2 63.2 280.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "89.7 296.2 36.3 326.3 36.1 386.9 62.8 371.8 62.9 341.5 89.6 326.5 89.7 296.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.4 311.4 63 341.5 62.8 402.1 116.2 372 116.4 311.4"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "490 402.4 489.8 463 543 493.5 596.5 463.3 596.7 402.7 543.4 372.3 490 402.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "543.4 372.3 490 402.4 489.8 463 516.4 448 516.6 417.6 543.3 402.5 543.4 372.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "569.9 387.5 516.5 417.6 516.3 478.2 543 463.2 543.1 432.9 569.8 417.9 569.9 387.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "596.7 402.7 543.2 432.9 543 493.5 596.5 463.3 596.7 402.7"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "383.3 402.4 383.1 463 436.3 493.5 489.8 463.3 490 402.7 436.7 372.3 383.3 402.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "436.7 372.3 383.3 402.4 383.1 463 409.7 448 409.9 417.6 436.6 402.5 436.7 372.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "463.3 387.5 409.8 417.6 409.6 478.2 436.3 463.2 436.4 432.9 463.2 417.9 463.3 387.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "490 402.7 436.5 432.9 436.3 493.5 489.8 463.3 490 402.7"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "276.6 402.4 276.4 463 329.7 493.5 383.1 463.3 383.3 402.7 330 372.3 276.6 402.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "330 372.3 276.6 402.4 276.4 463 303 448 303.2 417.6 329.9 402.5 330 372.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "356.6 387.5 303.1 417.6 302.9 478.2 329.6 463.2 329.8 432.9 356.5 417.9 356.6 387.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "383.3 402.7 329.8 432.9 329.7 493.5 383.1 463.3 383.3 402.7"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "169.7 402.3 169.5 462.9 222.7 493.4 276.2 463.2 276.4 402.6 223.1 372.2 169.7 402.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.1 372.2 169.7 402.3 169.5 462.9 196.1 447.9 196.3 417.5 223 402.4 223.1 372.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "249.6 387.4 196.2 417.5 196 478.1 222.7 463.1 222.8 432.8 249.5 417.8 249.6 387.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "276.4 402.6 222.9 432.8 222.7 493.4 276.2 463.2 276.4 402.6"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63 402.1 62.8 462.7 116.1 493.2 169.5 463 169.7 402.5 116.5 372 63 402.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.5 372 63 402.1 62.8 462.7 89.5 447.7 89.7 417.4 116.4 402.2 116.5 372"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143 387.2 89.6 417.3 89.4 477.9 116.1 462.9 116.2 432.6 142.9 417.6 143 387.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "169.7 402.5 116.3 432.6 116.1 493.2 169.5 463 169.7 402.5"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "436.4 493.2 436.2 553.8 489.4 584.2 542.9 554.1 543.1 493.5 489.8 463.1 436.4 493.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "489.8 463.1 436.4 493.2 436.2 553.8 462.8 538.8 463 508.4 489.7 493.3 489.8 463.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "516.3 478.3 462.9 508.4 462.7 569 489.4 553.9 489.5 523.6 516.2 508.6 516.3 478.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "543.1 493.5 489.6 523.6 489.4 584.2 542.9 554.1 543.1 493.5"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "329.7 493.2 329.5 553.8 382.7 584.2 436.2 554.1 436.4 493.5 383.1 463.1 329.7 493.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "383.1 463.1 329.7 493.2 329.5 553.8 356.1 538.8 356.3 508.4 383 493.3 383.1 463.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "409.7 478.3 356.2 508.4 356 569 382.7 553.9 382.8 523.6 409.6 508.6 409.7 478.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "436.4 493.5 382.9 523.6 382.7 584.2 436.2 554.1 436.4 493.5"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223 493.4 222.8 554 276.1 584.4 329.5 554.3 329.7 493.7 276.5 463.3 223 493.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "276.5 463.3 223 493.4 222.8 554 249.4 539 249.6 508.6 276.4 493.5 276.5 463.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "303 478.5 249.5 508.6 249.3 569.2 276.1 554.2 276.2 523.9 302.9 508.9 303 478.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "329.7 493.7 276.3 523.9 276.1 584.4 329.5 554.3 329.7 493.7"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.3 493.3 116.1 553.9 169.4 584.4 222.8 554.2 223 493.7 169.8 463.2 116.3 493.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "169.8 463.2 116.3 493.3 116.1 553.9 142.7 538.9 142.9 508.6 169.7 493.4 169.8 463.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196.3 478.4 142.8 508.6 142.6 569.1 169.4 554.1 169.5 523.8 196.2 508.8 196.3 478.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223 493.7 169.6 523.8 169.4 584.4 222.8 554.2 223 493.7"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.5 493 9.3 553.6 62.5 584 116 553.9 116.2 493.3 62.9 462.9 9.5 493"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.9 462.9 9.5 493 9.3 553.6 35.9 538.6 36.1 508.2 62.8 493.1 62.9 462.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "89.4 478.1 36 508.2 35.8 568.8 62.5 553.8 62.6 523.5 89.3 508.5 89.4 478.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.2 493.3 62.7 523.5 62.5 584 116 553.9 116.2 493.3"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "543 493.6 542.8 554.2 596.1 584.6 649.5 554.5 649.7 493.9 596.5 463.4 543 493.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "596.5 463.4 543 493.6 542.8 554.2 569.5 539.2 569.7 508.8 596.4 493.7 596.5 463.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "623 478.7 569.6 508.8 569.4 569.4 596.1 554.3 596.2 524 622.9 509 623 478.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "649.7 493.9 596.3 524 596.1 584.6 649.5 554.5 649.7 493.9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonLeftCorner);
export default __webpack_public_path__ + "static/media/hexagon-left-corner.f3bf7cfeb248ce7500f1155f04dfbd34.svg";
export { ForwardRef as ReactComponent };